import type { Scene, SceneTimelineUpdateItem } from '../types';
import apiRequest from './apiRequest';

export type SceneReferenceUpdateRequest = {
  objectID?: string;
  stitchFromIndex?: number;
  timeline: SceneTimelineUpdateItem[];
};

export default async function postExternalSceneReference(
  apiKey: string,
  sceneID: string,
  referenceName: string,
  request: SceneReferenceUpdateRequest,
) {
  return await apiRequest<Scene>(
    'external-mogen',
    `/scenes/${encodeURIComponent(sceneID)}/${encodeURIComponent(referenceName)}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify(request),
    },
  );
}
